import { render, staticRenderFns } from "./Marketplaces.vue?vue&type=template&id=22141b98&"
import script from "./Marketplaces.vue?vue&type=script&lang=js&"
export * from "./Marketplaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports